import CmsModules from "theme/libs/wordpress/content/CmsModules";
import PageWrapper from "theme/components/wrappers/PageWrapper";
import PropTypes from "prop-types";
import React from "react";
import formatDate from "core-web/utils/formatDate";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const Default = ({ data }) => {
    const { t } = useTranslation();
    const blogPath = useSelector(({ application }) => application.config?.options?.specified_pages?.magazine);

    const {
        title,
        created_at: createdAt,
        page_content: pageContent,
        primary_category: primaryCategory,
        hero_content: heroContent,
    } = data;

    const locale = useSelector(({ application }) => application.locale);
    const iosDateFormatFix = `${createdAt.replace(" ", "T")}Z`;
    const date = new Date(iosDateFormatFix);
    const created = formatDate(date, "d MMMM yyyy", locale);

    const breadcrumbs = [{ permalink: "/", title: t("home") }];

    const relatedArticlesContent = {
        articles_selection: [{ articles_amount: 8, layout: "category", category: primaryCategory }],
        settings: {
            heading: t("articles.related"),
        },
    };

    if (blogPath) {
        relatedArticlesContent.settings["button"] = {
            label: t("articles.related_button"),
            link: blogPath,
        };

        breadcrumbs.push({
            permalink: blogPath,
            title: t("articles.collection_title"),
        });

        if (primaryCategory?.name) {
            breadcrumbs.push({
                permalink: `${blogPath}?category=${encodeURIComponent(primaryCategory.name)}`,
                title: primaryCategory.name,
            });
        }
    }

    breadcrumbs.push({ permalink: null, title });

    return (
        <PageWrapper>
            <CmsModules
                isHero
                isArticle
                createdAt={created}
                data={
                    heroContent && Array.isArray(heroContent) && heroContent.length > 0
                        ? heroContent[0]
                        : { layout: "hero_placeholder" }
                }
                breadcrumbs={breadcrumbs}
            />
            <CmsModules data={pageContent} />
        </PageWrapper>
    );
};

Default.propTypes = {
    data: PropTypes.object.isRequired,
};

export default Default;
